<template>
	<div v-if="false" />
</template>

<script>
import { isValidChannel } from "@/common/experiments";

export default {
	name: "ExperimentOverride",
	created() {
		if (this.$route.query.abexp) {
			const channel = this.$route.query.abexp;
			if (isValidChannel(channel)) {
				console.debug(
					`Updating the A/B experiment to channel ${channel}`
				);
				const cookieData = {
					overrideChannel: channel,
				};
				this.$store.commit("loadExperiments", cookieData);
			}
		}
	},
};
</script>
